<template>
  <div class="flex-grow-1 p-4">
    <filter-form @get-option-done="saveFilterParams" @filter="saveFilterParams" @exportTable="exportTable" />

    <el-table ref="tableRef" class="w-100" :data="tableData" row-key="id" @sort-change="onSortChange">
      <el-table-column prop="CharacterType" label="人物类型" width="120" />
      <el-table-column prop="GenderType" label="性别" width="120" />
      <el-table-column prop="Resource" width="140">
        <template #header>
          资源ID
          <el-button v-show="!sortField" type="primary" size="mini" @click="toggleRow('assetId')">{{ expands.assetId ? '展开' : '折叠' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="Quality" width="140">
        <template #header>
          质量等级
          <el-button v-show="!sortField" type="primary" size="mini" @click="toggleRow('quality')">{{ expands.quality ? '展开' : '折叠' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column v-if="visiblePartType" prop="ResourceType" width="140">
        <template #header>  
          资源类型
          <el-button v-show="!sortField" type="primary" size="mini" @click="toggleRow('partType')">{{ expands.partType ? '展开' : '折叠' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column v-if="visibleBase" prop="baseResource" label="基础资源" #default="{row}" width="120">
        {{ row.nodeType ? `${row.nodeType} - ${row.nodeName}` : '' }}
      </el-table-column>
      <el-table-column v-if="filterParams?.filterItem.includes('Triangles')" prop="Triangles" label="Triangles" sortable="custom" width="160" #default="{row}">
        <div v-html="getColumn(row, 'Triangles')"></div>
      </el-table-column>
      <el-table-column v-if="filterParams?.filterItem.includes('MaxDrawCalls')" prop="MaxDrawCalls" label="MaxDrawCalls" sortable="custom" width="160" #default="{row}">
        <div v-html="getColumn(row, 'MaxDrawCalls')"></div>
      </el-table-column>
      <el-table-column v-if="filterParams?.filterItem.includes('FX_Triangles')" label="FX_Triangles" sortable="custom" width="160" #default="{row}">
        <div v-html="getColumn(row, 'FX_Triangles')"></div>
      </el-table-column>
      <el-table-column v-if="filterParams?.filterItem.includes('AssetBundleSize')" label="AssetBundleSize" sortable="custom" width="160" #default="{row}">
        <div v-html="getColumn(row, 'AssetBundleSize')"></div>
      </el-table-column>
      <el-table-column v-if="filterParams?.filterItem.includes('FxsDrawCalls') && filterParams?.partType == 'Suit'" prop="FxsDrawCalls" label="FxsDrawCalls" sortable="custom" width="160" #default="{row}">
        <div v-html="getColumn(row, 'FxsDrawCalls')"></div>
      </el-table-column>
      <el-table-column v-if="filterParams?.filterItem.includes('Hair_DrawCalls')" label="Hair_DrawCalls" sortable="custom" width="160" #default="{row}">
        <div v-html="getColumn(row, 'Hair_DrawCalls')"></div>
      </el-table-column>
      <el-table-column v-if="filterParams?.filterItem.includes('Face_DrawCalls')" label="Face_DrawCalls" sortable="custom" width="160" #default="{row}">
        <div v-html="getColumn(row, 'Face_DrawCalls')"></div>
      </el-table-column>
      <el-table-column v-if="filterParams?.filterItem.includes('Top_DrawCalls')" label="Top_DrawCalls" sortable="custom" width="160" #default="{row}">
        <div v-html="getColumn(row, 'Top_DrawCalls')"></div>
      </el-table-column>
      <el-table-column v-if="filterParams?.filterItem.includes('Bottom_DrawCalls')" label="Bottom_DrawCalls" sortable="custom" width="180" #default="{row}">
        <div v-html="getColumn(row, 'Bottom_DrawCalls')"></div>
      </el-table-column>
      <el-table-column v-if="filterParams?.filterItem.includes('Shoe_DrawCalls')" label="Shoe_DrawCalls" sortable="custom" width="160" #default="{row}">
        <div v-html="getColumn(row, 'Shoe_DrawCalls')"></div>
      </el-table-column>

      <el-table-column prop="FlagAccord" label="超标情况" width="120" #default="{row}">
        {{ flagAccordOption[row.FlagAccord] }}
      </el-table-column>
      <el-table-column prop="" label="测试备注" width="120"></el-table-column>
    </el-table>

    <el-pagination v-model:current-page="page" class="text-end mt-3" size="large" @current-change="fetchTableData" layout="prev, pager, next" :total="total" />
  </div>
</template>

<script>
import {ref, computed, nextTick} from 'vue'
import {useRoute} from 'vue-router'
import axios from 'axios'
import FilterForm from './filter-form.vue'
import {getColumn} from '../common'

function useTableExpansion(tableData, tableRef) { //一键展开折叠功能
  let expands = ref({
      assetId: true,
      quality: true,
      partType: true,
    })

  function toggleRow(type, expand = expands.value[type]) {
    if (expand) { //展开
      tableData.value.forEach(assetId => {
        if (['partType', 'quality', 'assetId'].includes(type)) tableRef.value.toggleRowExpansion(assetId, expand)

        assetId.children.forEach(quality => {
          if (['partType', 'quality'].includes(type)) tableRef.value.toggleRowExpansion(quality, expand)

          quality.children.forEach(partType => {
            if (['partType'].includes(type)) tableRef.value.toggleRowExpansion(partType, expand)
          })
        })
      })

      if (['partType', 'quality', 'assetId'].includes(type)) expands.value.assetId = false
      if (['partType', 'quality'].includes(type)) expands.value.quality = false
      if (['partType'].includes(type)) expands.value.partType = false
    } else {
      tableData.value.forEach(assetId => {
        if (['assetId'].includes(type)) tableRef.value.toggleRowExpansion(assetId, expand)

        assetId.children.forEach(quality => {
          if (['assetId', 'quality'].includes(type)) tableRef.value.toggleRowExpansion(quality, expand)

          quality.children.forEach(partType => {
            if (['assetId', 'quality', 'partType'].includes(type)) tableRef.value.toggleRowExpansion(partType, expand)
          })
        })
      })

      if (['assetId'].includes(type)) expands.value.assetId = true
      if (['assetId', 'quality'].includes(type)) expands.value.quality = true
      if (['assetId', 'quality', 'partType'].includes(type)) expands.value.partType = true
    }
  }

  return {expands, toggleRow}
}

function useTableTree() { //将表格数据转为前端需要的结构
  function getBaseResource(arr, nodeType, nodeNameField) {
    return arr.map(item => {
      let nodeName = item[nodeNameField]
      if (nodeNameField == 'AssetPath') {
        const paths = item[nodeNameField].split('/')
        nodeName = paths[paths.length - 1]
      }

      return {
        id: Math.random(),
        nodeType,
        nodeName
      }
    })
  }

  function getAllBase({AnimationsReference, MaterialsReference, MeshesReference} = {}) {
    return [
      ...getBaseResource(AnimationsReference, 'AnimationsReference', 'AssetPath'),
      ...getBaseResource(MaterialsReference, 'MaterialsReference', 'AssetPath'),
      ...getBaseResource(MeshesReference, 'MeshesReference', 'MeshNodeName'),
    ]
  }

  function toTreeArr2(obj, field) {
    return Object.entries(obj).map(([key, value]) => {
      const {allTriangles, maxDrawCalls, FlagAccord, Threshold, SeriousThreshold, FxsDrawCalls, FX_Triangles, AssetBundleSize, Hair_DrawCalls, Face_DrawCalls, Top_DrawCalls, Bottom_DrawCalls, Shoe_DrawCalls} = value[0]
      const baseResource = getAllBase(value[0])

      return {
        id: Math.random(),
        [field]: key,
        Triangles: allTriangles, 
        MaxDrawCalls: maxDrawCalls, 
        FxsDrawCalls,
        FX_Triangles,
        AssetBundleSize,
        Hair_DrawCalls,
        Face_DrawCalls,
        Top_DrawCalls,
        Bottom_DrawCalls,
        Shoe_DrawCalls,
        FlagAccord,
        Threshold,
        SeriousThreshold,
        children: baseResource
      }
    })
  }
  
  function toTreeArr(obj, field) { //将对象转为树状数组结构
    return Object.entries(obj).map(([key, value]) => {
      const partTypes = toTreeArr2(value, 'ResourceType')
      let allTriangles = 0,
        maxDrawCalls = 0,
        FlagAccord = -1

      partTypes.forEach(item => {
        allTriangles += item.allTriangles
        maxDrawCalls += item.maxDrawCalls
        FlagAccord = Math.max(FlagAccord, item.FlagAccord)
      })

      return {
        id: Math.random(),
        [field]: key,
        // allTriangles: '-',
        // maxDrawCalls: '-',
        //FlagAccord,
        children: partTypes
      }
    })
  }

  function getTreeTable(tableData) {
    let result = []

    Object.entries(tableData).forEach(([CharacterType, RoleTypeValue]) => {
      Object.entries(RoleTypeValue).forEach(([GenderType, genderTypeValue]) => {
        Object.entries(genderTypeValue).forEach(([Resource, AssetIDValue]) => { //从资源ID开始展开
          const assetIds = toTreeArr(AssetIDValue, 'Quality')
          let FlagAccord = -1

          assetIds.forEach(item => {
            FlagAccord = Math.max(FlagAccord, item.FlagAccord)
          })

          result.push({
            id: Math.random(),
            CharacterType,
            GenderType,
            Resource,
            // allTriangles: '-',
            // maxDrawCalls: '-',
            FlagAccord,
            children: assetIds
          })
        })
      })
    })

    return result
  }

  return {getTreeTable, getAllBase}
}

export default {
  components: {FilterForm},

  setup() {
    const flagAccordOption = {
        1: '合规',
        2: '不合规',
        3: '严重不合规'
      },
      fieldOption = {
        Triangles: 'allTriangles',
        MaxDrawCalls: 'maxDrawCalls'
      },
      route = useRoute()
    let page = ref(1),
      total = ref(0),
      filterParams = ref({
        filterItem: []
      }),
      sortField = ref(''),
      sortOrder = ref(''),
      tableData = ref([]),
      tableRef = ref(null),
      visibleBase = computed(() => {
        return !sortField.value || (filterParams.value.sortLevel == 'base')
      }),
      visiblePartType = computed(() => {
        return !sortField.value || (filterParams.value.sortLevel != 'quality')
      }),
      {getTreeTable, getAllBase} = useTableTree(),
      {expands, toggleRow} = useTableExpansion(tableData, tableRef)

    function onSortChange(data) {
      sortField.value = fieldOption[data.prop] || data.prop
      sortOrder.value = data.order == 'ascending' ? 0 : 1
      fetchTableData()
    }

    async function saveFilterParams(params) {
      filterParams.value = JSON.parse(JSON.stringify(params))
      fetchTableData()
    }

    function getParams() {
      const params = filterParams.value

      return {
        project: route.query.project,
        version: params.version,
        scan_time: params.testTime,
        character_type: params.character_type.join(','),
        gender_type: params.gender_type.join(','),
        resource: params.resource.join(','),
        rarity: params.rarity.join(','),
        quality: params.partQuality.join(','),
        resource_type: params.partType.join(','),
        interval_key: params.filterItem.join(','),
        expandLevel: params.expandLevel,
        filter_type: params.filterOption,
        grade: params.grade.join(','),
        threshold: `${params.thresholdStart},${params.thresholdEnd}`,
        sort_field: sortField.value,
        reverse: sortOrder.value,
        page: page.value,
      }
    }

    async function fetchTableData() {
      const params = getParams()
      let {data} = await axios.post('memory/resource_avatar_data_overall/', params)

      if (sortField.value) {
        tableData.value = data.data.map(row => {
          row.id = Math.random()
          row.Triangles = row.allTriangles
          row.MaxDrawCalls = row.maxDrawCalls
          //row.bases = getAllBase(row)
          return row
        })
      } else {
        tableData.value = getTreeTable(data.data)
        await nextTick()
        toggleRow(params.expandLevel, true)
      }
      total.value = data.num
    }

    async function exportTable() {
      const {data} = await axios.post('memory/resource_avatar_data_xlsx/', getParams(), {responseType: 'blob'})
      
      // 创建一个临时的 URL 指向这个 Blob 对象
      const url = URL.createObjectURL(data);

      // 创建一个 <a> 标签
      const link = document.createElement('a');
      link.href = url;
      link.download = 'resource_scan'; // 设置下载的文件名

      // 将 <a> 标签添加到 DOM 中并触发点击事件
      document.body.appendChild(link);
      link.click();

      // 移除 <a> 标签并释放 URL 对象
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }

    return {filterParams, expands, flagAccordOption, page, total, sortField, tableData, tableRef, visibleBase, visiblePartType, onSortChange, fetchTableData, exportTable, toggleRow, saveFilterParams, getColumn}
  }
}
</script>